import { render, staticRenderFns } from "./ProcessedCommissions.vue?vue&type=template&id=a788c542&scoped=true&"
import script from "./ProcessedCommissions.vue?vue&type=script&lang=js&"
export * from "./ProcessedCommissions.vue?vue&type=script&lang=js&"
import style0 from "./ProcessedCommissions.vue?vue&type=style&index=0&id=a788c542&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a788c542",
  null
  
)

export default component.exports